/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import styled from 'styled-components';
import { ScreenReaderOnly } from '../../../ScreenReaderOnly';
import { SortIndicator, useTableSort } from '../Controls';
import { StyledTH, cellFlexAlignmentStyles } from '../styles';
// outline-offset ensure the focus outline isn't cutoff by the th boundaries
const SortableHeaderCellButton = styled.button `
  width: 100%;
  min-height: 44px;
  height: 100%;
  cursor: pointer;
  outline-offset: -1px;
`;
// adding padding to the cell content to ensure that the entire th
// area is clickable - padding is removed from the th when sortable
const HeaderCellButtonContent = styled.span `
  ${cellFlexAlignmentStyles}
  ${({ theme: { space } }) => `
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 ${space.md};
  `}
`;
const HeaderCell = ({ column, tableCaption, getAriaLiveSort, }) => {
    const { ariaLabel, isSorted = false, isSortable = false, getHeaderProps, getSortByToggleProps, render, alignment, } = column;
    const ref = useRef(null);
    const { sortState, safeColumnName } = useTableSort({
        column,
        tableCaption,
        getAriaLiveSort,
    });
    if (isSortable) {
        return (React.createElement(StyledTH, Object.assign({ ref: ref, scope: "col" }, getHeaderProps(), (sortState !== 'none' ? { 'aria-sort': sortState } : {}), { isSortable: true }),
            React.createElement(SortableHeaderCellButton, Object.assign({}, Object.assign(Object.assign({}, getSortByToggleProps()), { title: undefined }), (ariaLabel && { 'aria-label': ariaLabel }), { "data-track-name": `${safeColumnName} (sort)`, "data-track-state": sortState }),
                React.createElement(HeaderCellButtonContent, { alignment: alignment },
                    isSorted && React.createElement(SortIndicator, { sortState: sortState }),
                    render('Header')))));
    }
    return (React.createElement(StyledTH, Object.assign({ scope: "col", alignment: alignment }, getHeaderProps()), ariaLabel ? (React.createElement(React.Fragment, null,
        React.createElement(ScreenReaderOnly, { as: "span" }, ariaLabel),
        React.createElement("span", { "aria-hidden": "true" }, render('Header')))) : (render('Header'))));
};
export { HeaderCell };
//# sourceMappingURL=HeaderCell.js.map